import { Dialog, Transition } from '@headlessui/react';

import * as React from 'react';
import { Fragment } from 'react';

import oneshiftByCarousellLogo from '_images/oneshift-by-carousell-logo.png';

import { menuItems } from './HeaderMenu';
import MenuSlideDown from './MenuSlideDown';

function MenuSlideout({ show, openMenu, onClose }) {
  return (
    <Transition.Root show={show} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-in-out duration-500"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in-out duration-500"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 left-0 flex max-w-full pr-24">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-300"
                enterFrom="-translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-300"
                leaveFrom="translate-x-0"
                leaveTo="-translate-x-full"
              >
                <Dialog.Panel className="pointer-events-auto w-screen max-w-md">
                  <div className="flex h-full flex-col overflow-y-auto bg-white shadow-xl">
                    <div className="px-4 py-3">
                      <div className="flex justify-between">
                        <div className="flex items-center">
                          <a href="/">
                            <img
                              src={oneshiftByCarousellLogo}
                              className="w-[69px] h-[24px]"
                              alt="OneShift Logo"
                            />
                          </a>
                        </div>
                        <button type="button" onClick={onClose}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="w-4 h-4 text-content-secondary"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M6 18 18 6M6 6l12 12"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                    <div className="relative flex-1 p-4 border-t">
                      <ul>
                        {menuItems.map((item, index) => (
                          <li key={index}>
                            <MenuSlideDown
                              title={item.name}
                              icon={item.icon}
                              items={item.children}
                              defaultOpen={openMenu === item.name}
                            />
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}

export default MenuSlideout;
